import { Box, Typography } from '@mui/material';

type OpsInlineBarProps = {
  label: string;
  value: number;
  max: number;
  warnThreshold?: number;
  height?: number;
};

export default function OpsInlineBar({ label, value, max, warnThreshold, height = 6 }: OpsInlineBarProps) {
  const scale = max > 0 ? max : Math.max(value, 1);
  const ratio = Math.min(value / scale, 1);
  const isWarn = warnThreshold != null ? value >= warnThreshold : value > 0 && ratio >= 0.8;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 72, flexShrink: 0 }}>
        {label}
      </Typography>
      <Box
        sx={{
          flex: 1,
          height,
          bgcolor: 'action.hover',
          borderRadius: 0.5,
          overflow: 'hidden',
          minWidth: 40,
        }}
      >
        <Box
          sx={{
            width: `${ratio * 100}%`,
            height: '100%',
            bgcolor: isWarn ? 'warning.main' : 'primary.main',
            opacity: isWarn ? 1 : 0.55,
            transition: 'width 0.2s ease',
          }}
        />
      </Box>
      <Typography variant="caption" sx={{ fontFamily: 'monospace', minWidth: 24, textAlign: 'right', flexShrink: 0 }}>
        {value}
      </Typography>
    </Box>
  );
}
